<div class="product-unit">
  {{ value | number: '1.0-0' }}&nbsp;
  <ng-container [ngSwitch]="unit">
    <span *ngSwitchCase="'GRAM'" i18n="@@WeightGramUnit">g</span>
    <span *ngSwitchCase="'MILLILITER'" i18n="@@WeightMlUnit">ml</span>
    <span *ngSwitchCase="'KILOGRAM'" i18n="@@WeightKgUnit">kg</span>
    <span *ngSwitchCase="'LITER'" i18n="@@WeightLUnit">l</span>
    <span *ngSwitchDefault i18n="@@WeightGramUnit">g</span>
  </ng-container>
</div>
